import { createServerFn } from "@tanstack/react-start";

import { authMiddleware, mondayBoards } from "@onesolution/middlewares";

import { NOTIFICATIONS_COLUMNS } from "@onesolution/constants/monday/notifications";
import { mondayClient } from "@onesolution/monday/monday";
import z from "zod";
import { wrapWithUseQuery } from "..";

const handler = createServerFn()
	.middleware([authMiddleware, mondayBoards])
	.validator(z.object({ onlyNotProcessed: z.boolean().optional() }).optional())
	.handler(async ({ context, data }) => {
		const notifs = await mondayClient.query.notifications(context, {
			onlyNotProcessed: false,
		});
		const pulses = await mondayClient.query.items({
			itemIds: notifs.map((n) => n.pulseId),
			columnIds: ["name"],
		});
		const out = notifs.map((i) => {
			return {
				...i,
				processed: JSON.parse(i.processed || "[]"),
				userIds: JSON.parse(i.userIds || "[]"),
				pulseName: pulses.find((p) => p.id === i.pulseId)?.name,
				boardName: Object.entries(context.boards).find(
					([_, id]) => id === i.boardId,
				)?.[0],
			};
		});

		return out;
	});

export const getCurrentUserNotifications = wrapWithUseQuery(
	"currentUserNotif",
	handler,
);

const handlerCount = createServerFn()
	.middleware([authMiddleware, mondayBoards])
	.handler(async ({ context }) => {
		const notifs = await mondayClient.query.notifications(context, {
			columnIds: [NOTIFICATIONS_COLUMNS.processed],
			onlyNotProcessed: true,
		});

		return notifs.length;
	});

export const getCurrentUserNotificationsCount = wrapWithUseQuery(
	"currentUserNotifCount",
	handlerCount,
);
